import l10n from "@/services/l10n";
import AccessControl from "@/services/AccessControl";

import { USER_GROUP_PERSON } from "@/constants";

export default [
  {
    name: "artists",
    path: "/artists",
    icon: "artists",
    meta: { title: l10n("ARTISTS") },
    component: () =>
      import(/* webpackChunkName: "showcase" */ "@/pages/Artists/Artists.vue")
  },
  {
    name: "popularArtists",
    path: "/artists/popular",
    icon: "artists",
    meta: { title: l10n("POPULAR_ARTISTS") },
    component: () =>
      import(
        /* webpackChunkName: "artists-list" */ "@/pages/Artists/ArtistsPopular.vue"
      )
  },
  {
    name: "latestArtists",
    path: "/artists/latest",
    icon: "artists",
    meta: { title: l10n("LATEST_ARTISTS") },
    component: () =>
      import(
        /* webpackChunkName: "artists-list" */ "@/pages/Artists/ArtistsLatest.vue"
      )
  },
  {
    name: "favoriteArtists",
    path: "/artists/favorite",
    icon: "artists",
    meta: { title: l10n("FAVORITES_ARTISTS") },
    beforeEnter: AccessControl.route(USER_GROUP_PERSON),
    component: () =>
      import(
        /* webpackChunkName: "artists-list" */ "@/pages/Artists/ArtistsFavorite.vue"
      )
  },
  {
    name: "artistTracks",
    path: "/artists/:id/tracks",
    icon: "artist",
    meta: { title: l10n("ARTIST_TRACKS") },
    component: () =>
      import(
        /* webpackChunkName: "tracks-list" */ "@/pages/Tracks/TracksByArtist.vue"
      )
  },
  {
    name: "artistAlbums",
    path: "/artists/:id/albums",
    icon: "artist",
    meta: { title: l10n("ARTIST_ALBUMS") },
    component: () =>
      import(
        /* webpackChunkName: "albums-list" */ "@/pages/Albums/AlbumsByArtist.vue"
      )
  },
  {
    name: "artist",
    path: "/artists/:id",
    icon: "artist",
    meta: { title: l10n("ARTIST") },
    component: () =>
      import(/* webpackChunkName: "fullview" */ "@/pages/Artists/Artist.vue")
  }
];
